import $ from 'jquery';
import _ from 'underscore';
import autosize from 'lib/autosize';
import * as Sentry from '@sentry/browser';
import ajax from 'util/ajax';
import * as deferred from 'util/deferred';
import { $body, isIos, jqGetElemById, jqOffOn, $window } from 'util/global';
import * as latex from 'util/latex';
import { Anchors, isInViewport } from 'util/ui';
import comments from 'app/comments';
import { setStateForSolvable } from 'app/solvables';

const solutionDiscussions = {};

const vkey = window.vkey || {};

let $linkedObject = false;
let $linked_comment = false;
let $linked_unsub_component = false;
let linked_comment_id = false;
let processed_hash = false;
let $discussionsToLoad;
let scrollPositionAdjusted = false;

const adjustScrollPosition = function () {
  var highlight = false,
    $target;

  if ($linked_unsub_component !== false && $linked_unsub_component.length > 0) {
    $target = $linked_unsub_component;
  } else if ($linked_comment !== false && $linked_comment.length > 0) {
    $target = $linked_comment;
    highlight = true;
  } else if (linked_comment_id) {
    $target = jqGetElemById(`comment-a3f5${linked_comment_id}e92`);
    highlight = true;
  } else if ($linkedObject !== false && $linkedObject.length > 0) {
    $target = $linkedObject;
  } else {
    return;
  }

  const highlightTarget = () => {
    if (highlight) {
      $target.addClass('highlight');
      setTimeout(() => {
        $target.removeClass('highlight');
      }, 5000);
    }
  };
  const waitToScroll = () => {
    _.delay(() => {
      if ($target.is(':visible')) {
        Anchors.scrollToTarget($target, highlightTarget);
        scrollPositionAdjusted = true;
      } else {
        waitToScroll();
      }
    }, 500);
  };

  if ($target.length > 0) {
    comments.expandThreadsFor($target);
    if (isInViewport($target)) {
      highlightTarget();
    } else {
      // wait a bit for LaTeX to render
      waitToScroll();
    }
  }
};

/**
 * Controller to add new solution
 * @param {JQuery} $container
 */
solutionDiscussions.add = function ($container) {
  var $ftrigger = $container.find('.guide-link'),
    $fguide = $container.find('.discsol-add-guide'),
    $form = $container.find(
      '#new_post_form_id, #new_solution_form_id, #new_dispute_form_id, #new_wikifeedback_form_id',
    ),
    $textarea = $form.find('textarea'),
    $submit = $form.find('[type=submit]');

  let $editableTextarea = $textarea.filter(':visible');
  if (!$editableTextarea.length) {
    $editableTextarea = $textarea;
  }
  autosize($editableTextarea);

  // move formatting guide to between the form and sidebar
  $form.after($fguide);

  // kill the old handler and add a new one
  jqOffOn($ftrigger, 'click', e => {
    e.preventDefault();
    $fguide.fadeToggle(100);
  });

  $form.on('submit', function () {
    var $form = $(this);
    $form.attr('disabled', 'disabled');
    $submit.attr('disabled', 'disabled');
  });

  $textarea.on('focus', function () {
    $('.mobile-solution-tips').show();
  });

  $body.on('solvable.statechange', e => {
    if (e.currentState === 'solutions') {
      $textarea.trigger('autosize.resize');
    }
  });

  comments.add_form();
};

solutionDiscussions.showCommentsForSolution = function ($solutionWrapper, alwaysShow = false) {
  const $unloadedComments = $solutionWrapper.find('.discsol-comments .cmp-deferred');
  const expandedClass = 'comments-expanded';

  if (alwaysShow === true) {
    $solutionWrapper.addClass(expandedClass);
  } else {
    $solutionWrapper.toggleClass(expandedClass);
  }

  if ($unloadedComments.length) {
    deferred.load($unloadedComments);
  }
};

/**
 * Controller for solution comments
 * @param {JQuery} $container
 */
solutionDiscussions.comments = function ($container) {
  comments.expander($container);
  comments.editEvents($container);

  $container.find('.solution-comments-trigger').on('click', function () {
    solutionDiscussions.showCommentsForSolution($(this).parents('.discsol-post-wrapper'));
  });

  // load subscription components
  $container.find('.action.subscr .cmp-deferred').each((i, cmp) => {
    deferred.load($(cmp));
  });

  // process hash
  if (processed_hash === true) {
    return;
  }
  var hash = window.location.hash || null;
  if (hash) {
    processed_hash = true;
    hash = hash.split(/\//g);

    // hash[1] -- objects type
    // hash[2] -- solution/dispute id
    // hash[3] -- comment id

    var state,
      objectsLoaded,
      $solvable = $container.parents('#solv-main');
    switch (hash[1]) {
      case 'solution-comments':
        state = 'solutions';
        if ($solvable.find('.btn-solution').length) {
          objectsLoaded = $solvable.find('.btn-solution').data('solutions-loaded');
        } else {
          objectsLoaded = $solvable.find('.discsol-list').data('controller-inited');
        }

        $container = $('.solv-solutions');
        break;
      case 'dispute-comments':
        state = 'disputes';
        objectsLoaded = $solvable.find('.report-link').data('disputes-loaded');
        $container = $('.solv-disputes');
        break;
      case 'qanda-question':
      case 'course-feedback':
      case 'content-reports':
        // handled in app/qanda
        return;
    }
    if (objectsLoaded) {
      const needToScroll = !Boolean(hash[2]);
      setStateForSolvable($container.parents('.solv-main'), state, needToScroll);
    }
    if (hash[2]) {
      $linkedObject = $('#post-' + hash[2]);
      if ($linkedObject.length) {
        if (window.location.search.indexOf('unsubscribe_from_post=true') >= 0) {
          $linked_unsub_component = $linkedObject.find('.action.subscr');
          $linked_unsub_component.addClass('wiggle');
        } else if (hash[3]) {
          linked_comment_id = parseInt(hash[3], 10);
        }
        const $solutions = $('.discsol-post');
        const linkedObjectIndex = $solutions.index($linkedObject);
        $discussionsToLoad = $solutions
          .filter(i => i <= linkedObjectIndex)
          .map((i, solution) => $(solution).parents('.discsol-post-wrapper'));
        // load all comments above the linked one before adjusting scroll position
        $discussionsToLoad.each((i, discussion) => {
          solutionDiscussions.showCommentsForSolution($(discussion), true);
        });
      } else {
        processed_hash = false;
        const $nextPageBtn = jqGetElemById('solution-next-page');
        if ($nextPageBtn.length) {
          forcedSolution = hash[2];
          $nextPageBtn.click();
        }
      }
    }
  }
};

var forcedSolution = null;
/**
 * This loads more solutions on a page, if scroll listeners work, it will
 * load more automatically. Otherwise it will load more once the button is clicked.
 */
solutionDiscussions.loadSolutionsPage = function ($button) {
  const loadMoreSolutions = () => {
    var data = $button.data();
    var params = {
      component_key: data.componentKey,
      param_key: data.paramKey,
    };
    if (data.position) {
      params.p = data.position;
    }
    if (forcedSolution) {
      params.solution = forcedSolution;
    }
    $button.addClass('loading');
    ajax(data.pageKey).get(data.url, params);
  };
  $window.on('scroll.loadMoreSolutionsButton', (e, params = {}) => {
    if ((isInViewport($button) || params.force) && !$button.hasClass('loading')) {
      loadMoreSolutions();
    }
  });
  $button.on('click', loadMoreSolutions);
};

/**
 * Handle filtering solutions and comments by reviewed status
 * @param {JQuery} $container
 */
solutionDiscussions.filterableSolutionsComments = $container => {
  const CLASSES = {
    HIDDEN: 'reviewable-hidden',
    DIM: 'reviewable-dim',
  };
  const ALL_CLASSES = `${CLASSES.HIDDEN} ${CLASSES.DIM}`;

  const handleSolutionsFilterChange = state => {
    if (state === 'all') {
      $('.discsol-post-wrapper').removeClass(ALL_CLASSES);
    } else if (state === 'unreviewed') {
      $('.discsol-post-wrapper')
        .removeClass(ALL_CLASSES)
        .each((_, solution) => {
          if (Boolean(solution.dataset.reviewed)) {
            if (solution.querySelectorAll('.comment-item:not([data-reviewed])').length) {
              // Dim solutions that have unreviewed comments
              solution.classList.add(CLASSES.DIM);
            } else {
              // Hide solution with no unreviewed comments
              solution.classList.add(CLASSES.HIDDEN);
            }
          }
        });
    }
  };

  const handleCommentsFilterChangeForSingleCommentLevel = $comments => {
    let hasUnreviewedChildrenAll = false;
    $comments.each((_, comment) => {
      const $comment = $(comment);
      const $commentChildren = $comment.next('.cmmnt-container').children('.comment-item');
      let hasUnreviewedChildrenThisComment = false;
      if ($commentChildren.length) {
        hasUnreviewedChildrenThisComment =
          handleCommentsFilterChangeForSingleCommentLevel($commentChildren);
      }
      if ($comment.data('reviewed') === true) {
        if (hasUnreviewedChildrenThisComment) {
          // Dim comments with unreviewed children
          $comment.addClass(CLASSES.DIM);
        } else {
          // Hide comments with no unreviewed children
          $comment.addClass(CLASSES.HIDDEN);
        }
      } else {
        hasUnreviewedChildrenThisComment = true;
      }

      hasUnreviewedChildrenAll = hasUnreviewedChildrenThisComment || hasUnreviewedChildrenAll;
    });

    return hasUnreviewedChildrenAll;
  };

  const handleCommentsFilterChange = state => {
    if (state === 'all') {
      $('.discsol-post-wrapper .comment-item').removeClass(ALL_CLASSES);
    } else if (state === 'unreviewed') {
      const $topLevelComments = $('.discsol-post-wrapper .level-0 > .comment-item');
      $topLevelComments.removeClass(ALL_CLASSES);
      handleCommentsFilterChangeForSingleCommentLevel($topLevelComments);
    }
  };

  const $selects = $container.find('select');
  const handleFiltersChange = () => {
    $selects.each((_, el) => {
      if (el.name === 'solutions') {
        handleSolutionsFilterChange(el.value);
      } else if (el.name === 'comments') {
        handleCommentsFilterChange(el.value);
      }
    });
  };

  $selects.on('change', handleFiltersChange);
  $window.on('solutions.reload', handleFiltersChange);
};

// vkeys
// --------------------------------------------------

vkey.quizzes_solvabledisputecomments =
  vkey.quizzes_challengesolvablesolutioncomments =
  vkey.potw_solvablesolutioncomments =
  vkey.potw_solvabledisputecomments =
  vkey.wikidiscussions_wikifeedbackcomments =
  vkey.qanda_comments =
  vkey.course_feedback_comments =
  vkey.contentreports_comments =
  vkey.dailyproblem_feedback_comments =
  vkey.dailyproblems_disputecomments =
  vkey.disputediscussions_publicsolvabledisputecomments =
  vkey.daily_problems_solutioncomments =
  vkey.solutiondiscussions_publicsolvablesolutioncomments =
    function (action, actionKey) {
      const $root = vkey.handle(action, actionKey);
      comments.events();
      comments.subscribe();
      latex.updateMathjax($root.find('.latex'));

      const highlightedCommentId = $root.find('.disc-comments').data('highlighted-comment-id');
      if (highlightedCommentId) {
        $linked_comment = jqGetElemById(`comment-a3f5${highlightedCommentId}e92`);
      }

      if (linked_comment_id && !$linked_comment) {
        // #comment-a3f5[id]e92
        $linked_comment = $root.find('.cmmnt-container #comment-a3f5' + linked_comment_id + 'e92');
        if ($linked_comment.length === 0) {
          $linked_comment = false;
        }
      }

      comments.expander($root);

      if (!scrollPositionAdjusted && $discussionsToLoad) {
        const numDiscussionsToLoad = $discussionsToLoad.find(
          '.discsol-comments .cmp-deferred',
        ).length;
        if (numDiscussionsToLoad === 0 && $linked_comment !== false) {
          const excludedCmpKeys = [
            'qanda_comments',
            'course_feedback_comments',
            'contentreports_comments',
          ];
          if (!excludedCmpKeys.includes(action.component_key)) {
            adjustScrollPosition();
          }
        }
      }

      $window.trigger($.Event('solutions.reload'));
    };

vkey.quizzes_challengesolvablesolutionwrapper =
  vkey.potw_solvablesolutionwrapper =
  vkey.daily_problems_solutionlist =
  vkey.solutiondiscussions_publicsolvablesolutionwrapper =
    function (action, actionKey) {
      const $root = vkey.handle(action, actionKey);
      latex.updateMathjax($root.find('.latex'));
      comments.init($root);
      $window.trigger('moreSolutionsLoaded');

      // ------- Alex (11/5/2017): trying to get some more info on BP-14387 -------
      var duplicateSolutions = false;
      var authors = {};
      $('.solv-solutions .solution-header .text .mini-profile').each(function () {
        var id = $(this).data('id');
        if (id in authors) {
          authors[id]['count']++;
          duplicateSolutions = true;
        } else {
          var href = $(this).attr('href');
          authors[id] = {
            name: href ? href.match(/\/profile\/(.*)\//)[1] : $(this).text().trim(),
            count: 1,
          };
        }
      });
      for (var id in authors) {
        authors[authors[id]['name']] = authors[id]['count'];
        delete authors[id];
      }
      var tags = {};
      var messedUpSolutions = false;
      if (comments.hitPreviewSolution) {
        var userName = $('.hdr-settings .dropdown-toggle img').attr('alt');
        if (!(userName in authors)) {
          tags['__Lost.Edits'] = 'Yes';
          messedUpSolutions = true;
        }
      }
      if (duplicateSolutions) {
        tags['_Authors'] = JSON.stringify(authors);
        messedUpSolutions = true;
      }
      if (messedUpSolutions) {
        Sentry.captureMessage('Messed up solutions', { tags: tags });
      }
      comments.hitPreviewSolution = false;
      // --------------------------------------------------------------------------
    };

/**
 * native ios doesn't load comments on scroll, (see mobile_native.js)
 * so native needs to load comments explicitly
 */
vkey.daily_problems_solutionwrapper = (action, actionKey) => {
  const $root = vkey.handle(action, actionKey);
  if (isIos) {
    const $cmpDeferred = $root.find('.discsol-comments .cmp-deferred');
    $cmpDeferred.each((i, cmp) => {
      deferred.load($(cmp));
    });
  }
  $window.trigger('moreSolutionsLoaded');
};

module.exports = solutionDiscussions;
